
export const INTERNATIONAL_PAYMENT_URL = 'https://remitly.tod8mp.net/kjBYGz';